import { XMLToJSON } from 'helpers/xmlToJson';


interface Cell {
    _: string;
}

interface Column {
    _: string;
    $: any;
}

interface Row {
    cell: Cell[];
}

interface Head {
    column: Column[];
}

interface DataConverted {
    rows: {
        head: Head[];
        row: Row[];
    };
}

export const getDataWidth = async (data: string) => {
    try {

        // const excludeFields = ['0'];
        const dataConverted: DataConverted = await XMLToJSON(data);
        // const dataWidths = dataConverted.rows.head[0]?.column.map(item => item.$.width).filter(header => !excludeFields.includes(header));;
        const dataWidths = dataConverted.rows.head[0]?.column.map(item => item.$.width);
        return dataWidths;

    } catch (error) {
        // console.error('Error processing data:', error);
    }
} 

